import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { colors } from "../../theme/color";

export default function DailogComponent({ title, children, actions, open }) {
  return (
    <Dialog
      open={open}
      PaperProps={{
        sx: {
          maxWidth: { xs: "90%", sm: 572 },
          borderRadius: "12px",
          p: 4,
          display: "flex",
          flexDirection: "column",
          gap: 5,
          border: `1px solid ${colors.tableColor}`,
        },
      }}
      className="gap-5"
    >
      <Box sx={{ display: "flex", flexDirection: "column", gap: 2.5 }}>
        <Box className="flex items-center justify-between ">
          <DialogTitle
            sx={{
              fontWeight: 600,
              p: 0,
              fontSize: { xs: "18px", sm: "25px" },
              wordBreak: "break-word",
              flex: 1,
            }}
          >
            {title}
          </DialogTitle>
        </Box>
        <DialogContent sx={{ fontWeight: 400, fontSize: "20px", p: 0 }}>
          {children}
        </DialogContent>
      </Box>

      {actions && (
        <DialogActions
          sx={{
            display: "flex",
            justifyContent: "space-between",
            gap: 2,
            p: 0,
          }}
        >
          {actions}
        </DialogActions>
      )}
    </Dialog>
  );
}

DailogComponent.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  title: PropTypes.node,
  children: PropTypes.node,
  actions: PropTypes.node,
  dialogProps: PropTypes.object,
  titleSx: PropTypes.object,
  contentSx: PropTypes.object,
  actionsSx: PropTypes.object,
};
